<form class="notification-list-search">
    <owc-input 
    variant="outlined" 
    placeholder="search"  
    rounded  
    (valueChange)="applyFilter($event.detail)"
    >
        <owc-icon slot="prefix" name="search" family="outlined"></owc-icon>
    </owc-input>
</form>
